import { Validate } from '@edgvr-front/util/validate';
import { CompanyName } from '../interface';
import { companyName } from '../schema';

export class CompanyHostDevicesListVO {
  private static configValidation = Validate.compile(
    CompanyHostDevicesListVO.configValidationSchema()
  );

  constructor(readonly value: CompanyHostDevicesList) {
    Validate.assert(CompanyHostDevicesListVO.configValidation, this.value);
  }

  private static configValidationSchema() {
    return {
      type: 'object',
      required: ['companyName'],
      properties: {
        companyName,
      },
      additionalProperties: false,
    };
  }
}

interface CompanyHostDevicesList {
  companyName: CompanyName;
}
